import {FilterOperator, IczTableDataSource} from '@icz/angular-table';
import {EntityType} from '|api/commons';
import {DocumentDto, FileDto} from '|api/document';
import {DocumentSearchService} from '|shared';

export class CrossReferenceEntityDataSource extends IczTableDataSource<DocumentDto | FileDto> {
  constructor(
    documentSearchService: DocumentSearchService,
    allowableEntityTypes: EntityType[],
    excludeEntityId: number,
  ) {
    super(searchParams => documentSearchService.globalSearch(searchParams));

    this.additionalSearchParams = {
      filter: [
        {
          fieldName: 'entityType',
          operator: FilterOperator.inSet,
          value: allowableEntityTypes,
        },
        {
          fieldName: 'id',
          operator: FilterOperator.notEquals,
          value: excludeEntityId,
        },
      ],
    };
  }
}
